<template>
  <div class="relative bg-login-image">
    <div>
      <div
        class="logo-testek h-12 w-20 absolute left-16 top-10 cursor-pointer"
        @click="backHome"
      ></div>
      <div class="style-form-login pb-10">
        <div
          testek="login-form"
          class="flex justify-center bg-login form-signin h-full items-center"
        >
          <div class="login-form flex justify-center">
            <div>
              <div class="flex items-center justify-center mt-4">
                <div class="text-3xl font-bold uppercase">
                  {{ $t("i18nCommon.ProductManage") }}
                </div>
              </div>
              <div
                class="mt-6 flex justify-center shadow-[0_25px_50px_25px_rgba(0,0,0,0.25)] transition-transform rounded-xl login-content bg-white"
              >
                <div>
                  <div class="flex justify-center mt-5 mb-6">
                    <div class="logo-system logo-login h-32 w-32"></div>
                  </div>
                  <a-form
                    :model="formState"
                    name="normal_login"
                    class="login-form"
                    @finish="onFinish"
                    @finishFailed="onFinishFailed"
                  >
                    <a-form-item
                      class="w-96"
                      name="username"
                      :rules="[
                        {
                          required: true,
                          message: `${$t('i18nCommon.userNameInvalid')}`,
                        },
                      ]"
                    >
                      <a-input
                        v-model:value="formState.username"
                        :placeholder="$t('i18nCommon.UserName')"
                      >
                      </a-input>
                    </a-form-item>

                    <a-form-item
                      class="w-96"
                      name="password"
                      :rules="[
                        {
                          required: true,
                          message: `${$t('i18nCommon.passwordInvalid')}`,
                        },
                      ]"
                    >
                      <a-input-password
                        v-model:value="formState.password"
                        :placeholder="$t('i18nCommon.Password')"
                      >
                        <template #prefix>
                          <LockOutlined
                            class="site-form-item-ico"
                            style="color: #d9d9d9"
                          />
                        </template>
                      </a-input-password>
                    </a-form-item>

                    <a-form-item class="w-96">
                      <div class="mt-2">
                        <a-button
                          class="w-96 text-whit btn-login text-2xl"
                          html-type="submit"
                          :width="384"
                          >{{ $t("i18nCommon.Login") }}</a-button
                        >
                      </div>
                      <div
                        class="mt-2 text-lg cursor-pointer hover:underline"
                        @click="forgotPassword"
                      >
                        {{ $t("i18nCommon.ForgotPassword") }}?
                      </div>
                      <div class="mt-2 text-lg cursor-pointer">
                        {{ $t("i18nCommon.HasAccount") }}
                        <span
                          class="ml-1 text-blue-800 cursor-pointer hover:text-blue-500 hover:underline"
                          @click="btnRegisterClick"
                        >
                          {{ $t("i18nCommon.Register") }}</span
                        >
                      </div>
                    </a-form-item>
                  </a-form>
                </div>
              </div>

              <div
                class="mt-4 justify-center shadow-[0_25px_50px_25px_rgba(0,0,0,0.25)] transition-transform rounded-xl login-info-default p-8 bg-white"
              >
                <div class="sign-in-as-info h-full">
                  <div
                    class="flex font-bold justify-center items-center text-xl"
                  >
                    {{ $t("i18nCommon.SignInAs") }}
                  </div>
                </div>
                <div class="mt-3">
                  <div
                    class="flex items-center justify-between user-info-default"
                  >
                    <div
                      class="text-xl mr-6 hover:underline active:underline cursor-pointer"
                      @click="selectAccount(account1)"
                    >
                      {{ $t("i18nCommon.Account1") }}
                    </div>
                    <div class="mr-20 text-xl">{{ account1.username }}</div>
                    <div class="text-xl">{{ account1.password }}</div>
                  </div>
                  <div
                    class="flex items-center justify-between mt-4 user-info-default"
                  >
                    <div
                      class="text-xl mr-6 hover:underline active:underline cursor-pointer"
                      @click="selectAccount(account2)"
                    >
                      {{ $t("i18nCommon.Account2") }}
                    </div>
                    <div class="mr-20 text-xl">{{ account2.username }}</div>
                    <div class="text-xl">{{ account2.password }}</div>
                  </div>
                  <!-- <div
                    class="flex items-center justify-between mt-4 user-info-default"
                  >
                    <div
                      class="text-xl mr-6 hover:underline active:underline cursor-pointer"
                      @click="selectAccount(account3)"
                    >
                      {{ $t("i18nCommon.Account3") }}
                    </div>
                    <div class="mr-20 text-xl">{{ account3.username }}</div>
                    <div class="text-xl">{{ account3.password }}</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="the-footer shadow-md transition-transform fixed left-0 right-0 bottom-0 h-10"
        testek="the-footer"
      >
        <div class="flex justify-between items-center pl-5 pr-5 h-full">
          <div class="text-base">Copyright @2024 - Testek</div>
          <div class="flex items-center">
            <div class="text-base">
              {{ $t("i18nCommon.TestekTitleDashboard") }}
            </div>
            <div class="ml-1 mr-1 text-lg">-</div>
            <div class="text-base">{{ $t("i18nCommon.HotLineZalo") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { ModuleAuth, ModuleUser } from "../../store/module-const";
export default {
  name: "Login",
  data() {
    return {
      formState: {
        username: "",
        password: "",
        remember: true,
      },
      rules: {},
      account1: {
        username: "admin_com_role",
        password: "aA12345678@",
      },
      account2: {
        username: "user_com_role",
        password: "aA12345678@",
      },
      account3: {
        username: "guest_com_role",
        password: "aA12345678@",
      },
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
  },
  methods: {
    ...mapMutations(["updateIsTokenExpired"]),
    ...mapActions(ModuleUser, ["loginUser"]),
    ...mapActions(ModuleAuth, [
      "LoginWithLocal",
      "changeMyPassword",
      "getMyProfile",
    ]),
    initDataStatic() {
      const me = this;
      me.rules = {
        userName: [
          {
            required: true,
            message: `${me.$t("i18nCommon.userNameInvalid")}`,
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: `${me.$t("i18nCommon.passwordInvalid")}`,
            trigger: "change",
          },
        ],
      };
    },
    async backToHome() {
      const me = this;
      let router = "/dashboard";
      me.$router.push(router);
      me.$emitter.emit("MenuActive", { router: router });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async onFinish(payload) {
      const me = this;
      if (!payload || !payload.username || !payload.password) {
        return;
      }

      let result = await this.LoginWithLocal(payload);
      //Đăng nhập thành công
      if (result && result.access_token && result.expires_in) {
        localStorage.setItem("Jwt", result.access_token);
        if (result.expires_in) {
          localStorage.setItem(
            "expires_at",
            Date.now() + result.expires_in * 1000
          );
          if (!this.$commonFunc.isTokenExpired()) {
            this.updateIsTokenExpired(false);
          }
        }
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.LoginSuccess")
        );
        this.backToHome();

        //lấy thông tin user
        let userProfile = await this.getMyProfile();
        if (userProfile) {
          localStorage.setItem(
            "userProfile",
            JSON.stringify({
              fullName: userProfile.fullName,
              email: userProfile.email,
            })
          );
        }
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.LoginFail"),
          "warning"
        );
        localStorage.removeItem("Jwt");
        localStorage.removeItem("expires_at");
      }
    },
    onFinishFailed(errorInfo) {
      console.log("Failed:", errorInfo);
    },
    btnRegisterClick() {
      const me = this;
      //me.$router.push("/register");
      me.$messageNotification.messageNotification(
        me.$t("i18nCommon.FeatureUnderDevelop"),
        "info"
      );
    },
    async forgotPassword(userId) {
      const me = this;
      // await me.changeMyPassword({ Id: userId });
      me.$messageNotification.messageNotification(
        me.$t("i18nCommon.FeatureUnderDevelop"),
        "info"
      );
    },
    backHome() {
      const me = this;
      let router = "/dashboard";
      me.$emitter.emit("MenuActive", { router: router });
      me.$router.push(router);
    },
    selectAccount(account) {
      const me = this;
      me.formState.username = account.username;
      me.formState.password = account.password;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-login {
  color: #000000e0;
}

::v-deep(.ant-input-affix-wrapper),
::v-deep(.ant-input) {
  background: none !important;
}

.btn-login {
  background: #6690f4;
  color: #fff;
  height: 48px;
  border-radius: 12px;
  cursor: pointer;

  &:active,
  &:hover {
    background-color: #4076f2;
    color: #fff;
    border-color: initial;
  }
}

.the-footer {
}

.login-info-default {
}

.sign-in-as-info {
}

.bg-login-image {
  background-image: url(@/assets/contents/logos/bg-login.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  min-height: 600px;
}

.style-form-login {
  height: calc(100vh - 38px);
  overflow: auto;
  padding-bottom: 40px;
}

/* Màn hình từ 1280px đến 1366px */
@media (min-width: 1280px) and (max-width: 1366px) {
  /* CSS cho laptop nhỏ */
  .login-content {
    width: 480px;
  }
}

/* Màn hình từ 1367px đến 1440px */
@media (min-width: 1367px) and (max-width: 1440px) {
  /* CSS cho laptop trung bình */
  .login-content {
    width: 480px;
  }
}

/* Màn hình từ 1441px đến 1920px */
@media (min-width: 1441px) and (max-width: 1920px) {
  /* CSS cho laptop lớn */
  .login-content {
    width: 480px;
  }
}
</style>
